//通过token获取用户信息
import request from "@/utils/request";

export function V2UserInfoForToken(params, config) {
    return request.get("/front/mailFrontUser/queryByIdByLogin", params, config);
}

